import api from './api';

class ErrorService {
  static TIMEOUT = 1000 * 120; // 10 segundos de timeout

  static handleApiError = (error) => {
    if (error.response) {
      // El servidor respondió con un código de estado fuera del rango 2xx
      console.error('Error de respuesta:', error.response.data);
      console.error('Código de estado:', error.response.status);
      throw new Error(`Error ${error.response.status}: ${error.response.data.message || 'Ocurrió un error en el servidor'}`);
    } else if (error.request) {
      // La solicitud se hizo pero no se recibió respuesta
      console.error('Error de solicitud:', error.request);
      throw new Error('No se recibió respuesta del servidor. Por favor, intente más tarde.');
    } else {
      // Algo sucedió al configurar la solicitud que desencadenó un error
      
      console.error('Error:', error.message);
      throw new Error('Ocurrió un error al procesar la solicitud. Por favor, intente de nuevo.');
    }
  };

  static withTimeout = (promise) => {
    return Promise.race([
      promise,
      new Promise((_, reject) =>
        setTimeout(() => reject(new Error('La solicitud ha excedido el tiempo de espera')), this.TIMEOUT)
      )
    ]);
  };

  static async makeRequest(method, url, data = null) {
    try {
      const response = await this.withTimeout(api[method](url, data));
      return response.data;
    } catch (error) {
      this.handleApiError(error);
    }
  }

  static get(url) {
    return this.makeRequest('get', url);
  }

  static post(url, data) {
    return this.makeRequest('post', url, data);
  }

  static put(url, data) {
    return this.makeRequest('put', url, data);
  }

  static delete(url) {
    return this.makeRequest('delete', url);
  }
  
}

export default ErrorService;